import { simpleFetch, closeErrorModal } from './acCommon'
import { history } from '../history'
import { bookingFlowValidateStepWelcome, bookingFlowMetaChange } from '../actions/acBookingFlow'

export const GET_AFFILIATE_PUBLIC_DATA_REQUEST = "GET_AFFILIATE_PUBLIC_DATA_REQUEST"
export const GET_AFFILIATE_PUBLIC_DATA_SUCCESS = "GET_AFFILIATE_PUBLIC_DATA_SUCCESS"
export const GET_AFFILIATE_PUBLIC_DATA_FAILURE = "GET_AFFILIATE_PUBLIC_DATA_FAILURE"

export const fetchAffiliate = id => (dispatch, getState) => {
	let url = '/public/affiliates/' + id
	let init = { method: 'GET' }
	dispatch(simpleFetch(url, init, 'GET_AFFILIATE_PUBLIC_DATA'))
		.then(({ actionType }) => {
			if (actionType === GET_AFFILIATE_PUBLIC_DATA_FAILURE) {
				history.push("/")
				dispatch(closeErrorModal())
			}
		})
}


export const jumpToBookingFlow = (affiliateID) => (dispatch, getState) => {
	dispatch(bookingFlowMetaChange({ options: { affiliateID: affiliateID }, allowAffiliateChange: false }))
	dispatch(bookingFlowValidateStepWelcome(affiliateID))
}




// WEBPACK FOOTER //
// ./src/actions/acAffiliatePage.js